export default "__VITE_ASSET__FUYCBiS4__"